import appClient from './AppClient';
import { endpoints } from '../../../config';

export type DecriptionResponse = {
    value: string;
};

class EncryptionService {
    async decryptData(value: string) {
        const request = {
            value
        };

        const url = endpoints.manageUrl + 'security/actions/decrypt';
        return appClient.post<DecriptionResponse>(url, request);
    }
}

export default EncryptionService;
